import { ClickNavigationProps } from '../../../../../components/NavigationWithSideBar/ClickNavigation'

import { ZohoContactSyncSettings } from './ZohoContactSyncSettings'

export const ZohoSpecificSettings = (): ClickNavigationProps[] => {
  return [{ id: 'contactSync', label: 'Contact Sync', content: () => <ZohoContactSyncSettings /> }]
}
